import { Components, Theme } from '@mui/material';
import { ICON_SIZES } from './const';

export default {
  styleOverrides: {
    fontSizeSmall: {
      fontSize: ICON_SIZES.SMALL,
    },
    fontSizeLarge: {
      fontSize: ICON_SIZES.LARGE,
    },
    fontSizeXlarge: {
      fontSize: ICON_SIZES.X_LARGE,
    },
    fontSizeXsmall: {
      fontSize: ICON_SIZES.X_SMALL,
    },
    root: ({ theme, ownerState }) => {
      const systemColors = ['inherit', 'action', 'disabled'];
      if (!ownerState.color || systemColors.includes(ownerState.color)) {
        return undefined;
      }
      type Color = Exclude<NonNullable<typeof ownerState.color>, 'inherit' | 'action' | 'disabled'>;
      return {
        color: theme.palette[ownerState.color as Color].outline,
      };
    }
  },
} as Components<Theme>['MuiIcon'];